import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "_mt-3" }
const _hoisted_2 = {
  "format-key": "0",
  class: "_mt-0 _tc--base",
  "data-qa": "stretch-pay-text"
}

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_themed_image = _resolveComponent("themed-image")
  const _component_localize = _resolveComponent("localize")
  const _component_progress_bar = _resolveComponent("progress-bar")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", null, [
      _createVNode(_component_localize, {
        resource: _ctx.Resources.ProjectHome.AddToCartSuccessModalInstallmentMissingAmountParagraph
      }, {
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_2, _toDisplayString($options.installmentMissingValue), 1 /* TEXT */),
          _createVNode(_component_themed_image, {
            "format-key": "1",
            src: "/content/images/static/stretch-pay/installments-logo.svg",
            alt: "stretchPay",
            width: "91"
          })
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["resource"])
    ]),
    _createVNode(_component_progress_bar, {
      value: $props.totalCost,
      max: $props.installmentsMinPaymentAmount,
      "progression-class": "gfu-progress-bar__progression--accent",
      class: "_mt-1"
    }, null, 8 /* PROPS */, ["value", "max"])
  ]))
}